import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderItemTrackingStatusEnum } from '@models';
import { DateTimePipe } from 'libs/core/src/lib/pipes';
import { DATE_LABELS_BY_STATUS } from './order-state-description.constant';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'lib-order-state-description',
  templateUrl: './order-state-description.component.html',
  styleUrl: './order-state-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, DateTimePipe, RouterModule],
})
export class OrderStateDescriptionComponent {
  status = input<OrderItemTrackingStatusEnum>();
  description = input<string>();
  date = input<string | undefined>();
  trackingNumber = input<string>();
  trackingLink = input<string | null>();
  learnMoreLink = input<string>();
  linkLabel = input<string>();
  showProjectedContent = input(true);

  dateLabel = computed(() => DATE_LABELS_BY_STATUS[this.status()!]);
  isDisplayTrackingNumber = computed(
    () =>
      this.trackingNumber() &&
      ![
        OrderItemTrackingStatusEnum.Canceled,
        OrderItemTrackingStatusEnum.Ordered,
        OrderItemTrackingStatusEnum.Returned,
      ].includes(this.status() as OrderItemTrackingStatusEnum),
  );

  redirect(): void {
    const link = this.trackingLink();
    if (!link) return;
    window.open(link, '_blank');
  }
}
